const AiConfirmCardTestIdsScope = {
  ROOT: 'ai-confirm-card',
};

export const AiConfirmCardTestIds = {
  APPROVE_BUTTON: `${AiConfirmCardTestIdsScope.ROOT}.approve-button`,
  DISMISS_BUTTON: `${AiConfirmCardTestIdsScope.ROOT}.dismiss-button`,
  REASON_INPUT: `${AiConfirmCardTestIdsScope.ROOT}.reason-input`,
  REASON_CANCEL: `${AiConfirmCardTestIdsScope.ROOT}.reason-cancel`,
  REASON_SUBMIT: `${AiConfirmCardTestIdsScope.ROOT}.reason-submit`,
  SLA_GROUP_SELECT: `${AiConfirmCardTestIdsScope.ROOT}.sla-group-select`,
};
